import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../routes/routeName';
import StepperCustom from '../../../components/step/Stepper';
import { EvidencePayment, FileApplicant, FormApplicant } from '../list-applicants/applicent-detail';
import ContainerButton from '../../../components/button/ContainerButton';
import { Box, Typography } from '@mui/material';
import StateComponents from '../../../components/state-component/StateComponents';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { AdmissionFrontApi } from '../../../api/admission-front/admission-front.api';
import moment from 'moment';
import { alertActive, alertError, alertSuccess } from '../../../components/alert/swal';
import { InterviewStudentApi } from '../../../api/interview-student/interview-student.api';
import ModalCustom from '../../../components/modal/ModalCustom';
import { ADMISSION_STATUS } from '../history-online-Admission/enum/admission.enum';
import { timeToView } from '../../../utils/date.utils';

export default function InterviewStudentDetail() {
    const { t } = useTranslation();
    const { id } = useParams()
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();
    const [remark, set_remark] = useState<string>("");

    const [form, setForm] = useState<any>();
    const [formInterview, setFormInterview] = useState<any>();
    const [tabStep, setTebStep] = useState(0);
    const [showModal, setShowModal] = useState<string>("");
    const handleCloseModal = () => {
        setShowModal("");
        set_remark('')
    }
    const allStep = [
        {
            name: t("INTERVIEW_STUDENT_PERSONAL_INFO"),
            isAccept: false,
            icon: null
        },
        {
            name: t("INTERVIEW_STUDENT_PAYMENT_PROOF"),
            isAccept: false,
            icon: null
        },
        {
            name: t("INTERVIEW_STUDENT_INTERVIEW_DETAILS"),
            isAccept: false,
            icon: null
        },

    ];
    const getDetail = async () => {
        dispatch(setLoading());

        await AdmissionFrontApi.findOne(id).then((res) => {
            if (res.status < 300) {
                setForm(res.data.data)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const getDetailInterview = async () => {

        await InterviewStudentApi.getInterviewStudentById(id).then((res) => {
            if (res.status < 300) {
                setFormInterview({...res.data.data,interview_student_time: res.data.data?.interview_student_date ? timeToView(res.data.data?.interview_student_date) : ''})
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
        })
    }
    useEffect(() => {
        getDetail()
        getDetailInterview()
    }, [])

    const handleSubmit = async () => {
        const body = [{
            ...formInterview,
            interview_student_date: `${formInterview?.interview_student_date}T${formInterview?.interview_student_time}`,
            id_admission_student: id
        }]
        dispatch(setLoading());
        if (id) {
            await InterviewStudentApi.createInterviewStudent(body)
                .then((res) => {
                    if (res.status < 300) {
                        alertSuccess(t("INTERVIEW_STUDENT_SAVE"), t("INTERVIEW_STUDENT_SAVE_COMPLETED"),undefined,() => {
                        navigate(routeName.admission.interview_student)

                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError(t("INTERVIEW_STUDENT_SAVE"), t("INTERVIEW_STUDENT_SAVE_FAILED"));
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        }
    }
    const handleAPPROVE = async (status: string) => {
        const body = [{
            id_interview_student: formInterview?.id_interview_student,
            id_admission_student: Number(id),
            interview_student_result: status,
            interview_student_result_remark: remark
        }]
        dispatch(setLoading());
        if (id) {
            await InterviewStudentApi.resultInterview(body)
                .then((res) => {
                    if (res.status < 300) {
                        alertSuccess(t("INTERVIEW_STUDENT_SAVE"), t("INTERVIEW_STUDENT_SAVE_COMPLETED"),undefined,() => {
                        navigate(routeName.admission.interview_student)

                        });
                        // navigate(routeName.admission.ManagePayment)
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError(t("INTERVIEW_STUDENT_SAVE"), t("INTERVIEW_STUDENT_SAVE_FAILED"));
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        }
    }
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("INTERVIEW_STUDENT_PERSONAL_INFO")}
                // hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("INTERVIEW_STUDENT_ENTRY_EXAM"),
                                disabled_match: true,
                                pathName: routeName.admission.interview_student
                            },
                            {
                                key: "complaintSubmit",
                                name: t("INTERVIEW_STUDENT_INTERVIEW"),
                                pathName: routeName.admission.interview_student
                            },
                            {
                                key: "complaintSubmit",
                                name: t("INTERVIEW_STUDENT_PERSONAL_INFO"),
                                pathName: routeName.admission.interview_student_detail
                            },
                        ]}
                    />
                }

                content={
                    <div className='w-full'>
                        <section
                            style={{
                                display: "flex",
                                justifyContent: "start",
                                marginTop: "24px",
                            }}
                        >
                            <StepperCustom
                                step={tabStep}
                                setStep={setTebStep}
                                stepLabel={allStep}
                                view={true}
                            />
                        </section>
                        {tabStep === 0 &&
                            <div style={{ display: 'flex', flexDirection: 'column', gap: "20px" }}>
                                <FormApplicant form={form} />
                                <FileApplicant form={form} />

                            </div>
                        }
                        {tabStep === 1 &&
                            <EvidencePayment form={form} />}
                        {tabStep === 2 &&
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', marginTop: "10px" }}>
                                {/* <Box sx={{
                                    display: 'flex', alignItems: 'center', gap: "10px"
                                }}>
                                    <Typography>ชื่อ - นามสกุล : Mr.Tana Made</Typography>
                                    <Typography>ฉายา : Buddha</Typography>
                                    <Typography>หลักสูตร : BA Buddhist Studies</Typography>

                                </Box> */}
                                <StateComponents
                                    otherProps={{ spacing: 2 }}
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "DATE",
                                            gridProps: {
                                                xs: 12,
                                                md: 3
                                            },
                                            fieldProps: {
                                                onChange: (e) => { setFormInterview({ ...formInterview, interview_student_date: moment(e).format('YYYY-MM-DD') }) },
                                                heading: t('INTERVIEW_STUDENT_INTERVIEW_DATE'),
                                                placeholder: t('INTERVIEW_STUDENT_INTERVIEW_DATE'),
                                                allowClear: true,
                                                onClear: () => {
                                                    setFormInterview({ ...formInterview, interview_student_date: '' })
                                                },
                                                value: formInterview?.interview_student_date || '',
                                                disabled: form?.admission_status === ADMISSION_STATUS.INTERVIEW_SUCCESS || form?.admission_status === ADMISSION_STATUS.INTERVIEW_FAILED
                                            },
                                        },
                                        {
                                            seq: 2,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 3
                                            },
                                            fieldProps: {
                                                heading: t("INTERVIEW_STUDENT_INTERVIEW_TIME"),
                                                onChange: (e) => {
                                                    setFormInterview({ ...formInterview, interview_student_time: e.target.value })
                                                },
                                                type: 'time',
                                                value: formInterview?.interview_student_time || '',
                                                disabled: form?.admission_status === ADMISSION_STATUS.INTERVIEW_SUCCESS || form?.admission_status === ADMISSION_STATUS.INTERVIEW_FAILED
                                            }
                                        },

                                        {
                                            seq: 6,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 6
                                            },
                                            fieldProps: {
                                                heading: t("INTERVIEW_STUDENT_INTERVIEW_LINK"),
                                                onChange: (e) => {
                                                    setFormInterview({ ...formInterview, interview_student_link: e.target.value })
                                                },
                                                value: formInterview?.interview_student_link || '',
                                                disabled: form?.admission_status === ADMISSION_STATUS.INTERVIEW_SUCCESS || form?.admission_status === ADMISSION_STATUS.INTERVIEW_FAILED
                                            }
                                        },
                                    ]} />
                            </Box>}
                        <ContainerButton
                            sxContainer={{ my: 3 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    buttonProps: {
                                        onClick: () => { navigate(-1) },
                                    },
                                    key: "CANCEL",
                                    label: t("INTERVIEW_STUDENT_BACK"),
                                    type: "CANCEL"
                                },

                                {
                                    seq: 2,
                                    hidden: tabStep !== 2 || form?.admission_status === ADMISSION_STATUS.WAITING_FOR_INTERVIEW || form?.admission_status === ADMISSION_STATUS.INTERVIEW_SUCCESS || form?.admission_status === ADMISSION_STATUS.INTERVIEW_FAILED,
                                    buttonProps: {
                                        onClick: () => {
                                            handleSubmit()
                                        }
                                    },
                                    key: "NONE",
                                    label: t("INTERVIEW_STUDENT_CONFIRM"),
                                    type: 'NONE'
                                },
                                // {
                                //     seq: 2,
                                //     hidden: tabStep !== 2  || form?.admission_status === ADMISSION_STATUS.PASSED_THE_EXAM|| form?.admission_status === ADMISSION_STATUS.INTERVIEW_SUCCESS || form?.admission_status === ADMISSION_STATUS.INTERVIEW_FAILED,
                                //     buttonProps: {
                                //         onClick: () => {

                                //             handleSubmit()
                                //         }
                                //     },
                                //     key: "NONE",
                                //     label: "แก้ไข",
                                //     type: "EDIT"
                                // },
                                {
                                    seq: 3,
                                    hidden: tabStep !== 2 || form?.admission_status === ADMISSION_STATUS.PASSED_THE_EXAM || form?.admission_status === ADMISSION_STATUS.INTERVIEW_SUCCESS || form?.admission_status === ADMISSION_STATUS.INTERVIEW_FAILED,
                                    buttonProps: {
                                        onClick: () => {
                                            alertActive(t("INTERVIEW_STUDENT_APPROVED"), t("INTERVIEW_STUDENT_CONFIRM_REVIEW"), undefined, undefined, async () => {
                                                handleAPPROVE('PASS')
                                            })
                                        }
                                    },
                                    key: "APPROVE",
                                    label: t("INTERVIEW_STUDENT_APPROVED"),
                                    type: "APPROVE"
                                },
                                {
                                    seq: 4,
                                    hidden: tabStep !== 2 || form?.admission_status === ADMISSION_STATUS.PASSED_THE_EXAM || form?.admission_status === ADMISSION_STATUS.INTERVIEW_SUCCESS || form?.admission_status === ADMISSION_STATUS.INTERVIEW_FAILED,
                                    buttonProps: {
                                        onClick: () => {
                                            // handleSubmit()
                                            // handleAPPROVE('NOT_PASS')
                                            setShowModal('REJECT')
                                        }
                                    },
                                    key: "REJECT",
                                    label: t("INTERVIEW_STUDENT_REJECTED"),
                                    type: 'REJECT'
                                },
                            ]}
                        />
                    </div>
                }
            />

            {showModal === 'REJECT' && (
                <ModalCustom
                    open
                    title={t('INTERVIEW_STUDENT_REJECTED')}
                    subTitle={t("INTERVIEW_STUDENT_NOTE")}
                    // maxWidth={600}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !remark,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => { handleAPPROVE("REJECT") }
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                otherProps={{ spacing: 2 }}
                                typeProps={[


                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            // md: 6
                                        },
                                        fieldProps: {
                                            heading: t("INTERVIEW_STUDENT_NOTE"),
                                            onChange: (e) => {
                                                set_remark(e.target.value)
                                            },
                                            value: remark || '',
                                            minRow: 6,
                                            multiline: true,
                                            inputHeight: 'auto'
                                        }
                                    },
                                ]} />
                        </div>
                    }
                />
            )}
        </div>
    )
}
